import { useQuery } from '@tanstack/react-query';
import { AlertApi } from '../../../apis/AlertApi/AlertApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IPatientNotification } from '../Alert';

export function usePatientAlertNotifications(alertId: number | null) {
    return useQuery<IPatientNotification[]>({
        queryKey: [QueryKeys.patientAlerts, 'notifications', alertId],
        queryFn: () => AlertApi.getPatientAlertNotifications(alertId!),
        enabled: !!alertId,
    });
}
